// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Weekday from "../../../../../../../to-be-migrated/domain/types/common/Weekday.bs.js";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Date$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as Switch$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/switch/Switch.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FormDateInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/deprecated/FormDateInput.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as CreateModificationUtils from "../../../../../../../pricing-dashboard/view/components/library/utils/CreateModificationUtils.bs.js";
import * as AllocationDashboardUtils from "../../../../utils/AllocationDashboardUtils.bs.js";
import * as TooltipComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/tooltip/TooltipComponent.bs.js";
import * as AllocationDashboardContent from "../../../../../../../pricing-dashboard/view/components/vm-mapper/AllocationDashboardContent.bs.js";
import * as AllocationCampaignFooterCmp from "../../reusable-components/AllocationCampaignFooterCmp.bs.js";
import * as FormKeyInputTimeTs$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormKeyInputTimeTs.bs.js";
import * as AllocationDashboardAssetsManager from "../../../../../assets/AllocationDashboardAssetsManager.bs.js";
import * as CreateZonalOrClusterCampaignForm from "./CreateZonalOrClusterCampaignForm.bs.js";
import * as FormSelectWithCheckboxInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectWithCheckboxInput.bs.js";

var cancelIcon = AllocationDashboardAssetsManager.getImage("cancel.svg");

var infoIcon = AllocationDashboardAssetsManager.getImage("info-icon.svg");

function getInitialFormState(saved_value, zones, clusters) {
  var c = saved_value.zones;
  var c$1 = saved_value.clusters;
  return {
          zones: c !== undefined ? List.map((function (a) {
                    return String(a.id);
                  }), List.filter(function (a) {
                        return List.exists((function (v) {
                                      return v === a.id;
                                    }), c);
                      })(zones)) : /* [] */0,
          hasCluster: saved_value.hasCluster,
          clusters: c$1 !== undefined ? List.map((function (a) {
                    return String(a.id);
                  }), List.filter(function (a) {
                        return List.exists((function (v) {
                                      return v === a.id;
                                    }), c$1);
                      })(clusters)) : /* [] */0,
          campaignName: saved_value.campaignName,
          startDate: saved_value.startDate,
          startTime: saved_value.startTime,
          endDate: saved_value.endDate,
          endTime: saved_value.endTime,
          days: saved_value.days,
          _type: saved_value._type,
          subType: saved_value.subType,
          displayFilters: saved_value.displayFilters,
          allocationRadiusManual: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getInitialValueForFormInput(saved_value.allocationRadiusManual),
          allocationRadiusAutomatic: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getInitialValueForFormInput(saved_value.allocationRadiusAutomatic),
          thresholdDistance: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getInitialValueForFormInput(saved_value.thresholdDistance),
          dryRunRatio: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getInitialValueForFormInput(saved_value.dryRunRatio),
          maxDryRunManual: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getInitialValueForFormInput(saved_value.maxDryRunManual),
          maxDryRunAutomatic: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getInitialValueForFormInput(saved_value.maxDryRunAutomatic)
        };
}

function sortDays(days) {
  var weekdayToIndex = Belt_List.map(days, (function (d) {
          return Weekday.weekdayToIndex(Weekday.fromString(d));
        }));
  var sortedDays = Belt_List.sort(weekdayToIndex, (function (a, b) {
          return a - b | 0;
        }));
  return Belt_List.map(sortedDays, (function (index) {
                return Weekday.toString(Weekday.indexToWeekday(index)).toLowerCase();
              }));
}

function CreateZonalOrClusterCampaigns(Props) {
  var state = Props.state;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var updateFormData = Props.updateFormData;
  var setFormMode = Props.setFormMode;
  var dispatch = Props.dispatch;
  var setShowClusterCampaigns = Props.setShowClusterCampaigns;
  var showClusterCampaigns = Props.showClusterCampaigns;
  var match = React.useState(function () {
        return false;
      });
  var setDisplayErrorText = match[1];
  var form = CreateZonalOrClusterCampaignForm.Form.useForm(getInitialFormState(state, zones, clusters), (function (output, _form) {
          var form_data_vehicle = state.vehicle;
          var form_data_geo_region = state.geo_region;
          var form_data_created_by = state.created_by;
          var form_data_zones = output.zones;
          var form_data_hasCluster = output.hasCluster;
          var form_data_clusters = output.clusters;
          var form_data_campaignName = output.campaignName;
          var form_data_startDate = output.startDate;
          var form_data_startTime = AllocationDashboardUtils.CreateZonalOrClusterCampaigns.adjustTimeWithDate(output.startDate, output.startTime);
          var form_data_endDate = output.endDate;
          var form_data_endTime = AllocationDashboardUtils.CreateZonalOrClusterCampaigns.adjustTimeWithDate(output.endDate, output.endTime);
          var form_data__type = output._type;
          var form_data_days = output.days;
          var form_data_subType = output.subType;
          var form_data_displayFilters = output.displayFilters;
          var form_data_allocationRadiusManual = output.allocationRadiusManual;
          var form_data_allocationRadiusAutomatic = output.allocationRadiusAutomatic;
          var form_data_thresholdDistance = output.thresholdDistance;
          var form_data_dryRunRatio = output.dryRunRatio;
          var form_data_maxDryRunManual = output.maxDryRunManual;
          var form_data_maxDryRunAutomatic = output.maxDryRunAutomatic;
          var form_data = {
            vehicle: form_data_vehicle,
            geo_region: form_data_geo_region,
            created_by: form_data_created_by,
            created_on: undefined,
            zones: form_data_zones,
            hasCluster: form_data_hasCluster,
            clusters: form_data_clusters,
            campaignName: form_data_campaignName,
            startDate: form_data_startDate,
            startTime: form_data_startTime,
            endDate: form_data_endDate,
            endTime: form_data_endTime,
            _type: form_data__type,
            days: form_data_days,
            subType: form_data_subType,
            displayFilters: form_data_displayFilters,
            allocationRadiusManual: form_data_allocationRadiusManual,
            allocationRadiusAutomatic: form_data_allocationRadiusAutomatic,
            thresholdDistance: form_data_thresholdDistance,
            dryRunRatio: form_data_dryRunRatio,
            maxDryRunManual: form_data_maxDryRunManual,
            maxDryRunAutomatic: form_data_maxDryRunAutomatic
          };
          Curry._1(updateFormData, (function (param) {
                  return form_data;
                }));
          return Curry._1(setFormMode, (function (param) {
                        return /* Preview */1;
                      }));
        }));
  React.useEffect((function () {
          if (List.length(form.input.zones) > 1) {
            Curry._2(form.updateHasCluster, (function (input, _value) {
                    return {
                            zones: input.zones,
                            hasCluster: false,
                            clusters: input.clusters,
                            campaignName: input.campaignName,
                            startDate: input.startDate,
                            startTime: input.startTime,
                            endDate: input.endDate,
                            endTime: input.endTime,
                            days: input.days,
                            _type: input._type,
                            subType: input.subType,
                            displayFilters: input.displayFilters,
                            allocationRadiusManual: input.allocationRadiusManual,
                            allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                            thresholdDistance: input.thresholdDistance,
                            dryRunRatio: input.dryRunRatio,
                            maxDryRunManual: input.maxDryRunManual,
                            maxDryRunAutomatic: input.maxDryRunAutomatic
                          };
                  }), false);
            Curry._1(setShowClusterCampaigns, (function (param) {
                    return false;
                  }));
          }
          Curry._2(form.updateClusters, (function (input, _value) {
                  return {
                          zones: input.zones,
                          hasCluster: input.hasCluster,
                          clusters: /* [] */0,
                          campaignName: input.campaignName,
                          startDate: input.startDate,
                          startTime: input.startTime,
                          endDate: input.endDate,
                          endTime: input.endTime,
                          days: input.days,
                          _type: input._type,
                          subType: input.subType,
                          displayFilters: input.displayFilters,
                          allocationRadiusManual: input.allocationRadiusManual,
                          allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                          thresholdDistance: input.thresholdDistance,
                          dryRunRatio: input.dryRunRatio,
                          maxDryRunManual: input.maxDryRunManual,
                          maxDryRunAutomatic: input.maxDryRunAutomatic
                        };
                }), /* [] */0);
          
        }), [
        form.input.zones,
        form.input.hasCluster
      ]);
  var value = form.input.campaignName;
  var match$1 = form.input.displayFilters;
  var tmp;
  if (form.input.displayFilters) {
    var value$1 = form.input.subType;
    var tmp$1;
    if (value$1 !== undefined) {
      switch (value$1) {
        case /* AllocationRadius */0 :
            tmp$1 = React.createElement("div", {
                  className: "ald-create-form-item-info-icon"
                }, "Allocation Radius", React.createElement(TooltipComponent$Catalyst.make, {
                      content: AllocationDashboardContent.allocation_radius_info_icon,
                      placement: /* Top_End */10,
                      children: React.createElement("img", {
                            className: "ald-create-form-item-info-icon-img",
                            src: infoIcon
                          })
                    }));
            break;
        case /* DryRun */1 :
            tmp$1 = React.createElement("div", {
                  className: "ald-create-form-item-info-icon"
                }, "Dry Run Ratio", React.createElement(TooltipComponent$Catalyst.make, {
                      content: AllocationDashboardContent.dry_run_info_icon,
                      placement: /* Top_End */10,
                      children: React.createElement("img", {
                            className: "ald-create-form-item-info-icon-img",
                            src: infoIcon
                          })
                    }));
            break;
        case /* MaxDryRun */2 :
            tmp$1 = React.createElement("div", {
                  className: "ald-create-form-item-info-icon"
                }, "Max Dry Run", React.createElement(TooltipComponent$Catalyst.make, {
                      content: AllocationDashboardContent.max_dry_run_info_icon,
                      placement: /* Top_End */10,
                      children: React.createElement("img", {
                            className: "ald-create-form-item-info-icon-img",
                            src: infoIcon
                          })
                    }));
            break;
        
      }
    } else {
      tmp$1 = null;
    }
    var match$2 = Belt_Option.getExn(form.input.subType);
    var tmp$2;
    switch (match$2) {
      case /* AllocationRadius */0 :
          var value$2 = form.input.allocationRadiusManual;
          var value$3 = form.input.allocationRadiusAutomatic;
          tmp$2 = React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "ald-create-form-item"
                  }, React.createElement("div", {
                        className: "ald-create-form-item-label"
                      }, "Manual ", React.createElement("label", {
                            className: "unit"
                          }, "(km)"), React.createElement("label", {
                            className: "required"
                          }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                return Curry._2(form.updateAllocationRadiusManual, (function (input, value) {
                                              return {
                                                      zones: input.zones,
                                                      hasCluster: input.hasCluster,
                                                      clusters: input.clusters,
                                                      campaignName: input.campaignName,
                                                      startDate: input.startDate,
                                                      startTime: input.startTime,
                                                      endDate: input.endDate,
                                                      endTime: input.endTime,
                                                      days: input.days,
                                                      _type: input._type,
                                                      subType: input.subType,
                                                      displayFilters: input.displayFilters,
                                                      allocationRadiusManual: value,
                                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                      thresholdDistance: input.thresholdDistance,
                                                      dryRunRatio: input.dryRunRatio,
                                                      maxDryRunManual: input.maxDryRunManual,
                                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), false, undefined, "", undefined, undefined, undefined, form.allocationRadiusManualResult, undefined, "ald-create-form-item-input", undefined, {
                              TAG: /* Text */0,
                              _0: "Value cannot be 0 or negative."
                            }, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: value$2 !== undefined ? value$2 : ""
                        }
                      })), React.createElement("div", {
                    className: "ald-create-form-item"
                  }, React.createElement("div", {
                        className: "ald-create-form-item-label"
                      }, "Automatic ", React.createElement("label", {
                            className: "unit"
                          }, "(km)"), React.createElement("label", {
                            className: "required"
                          }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                return Curry._2(form.updateAllocationRadiusAutomatic, (function (input, value) {
                                              return {
                                                      zones: input.zones,
                                                      hasCluster: input.hasCluster,
                                                      clusters: input.clusters,
                                                      campaignName: input.campaignName,
                                                      startDate: input.startDate,
                                                      startTime: input.startTime,
                                                      endDate: input.endDate,
                                                      endTime: input.endTime,
                                                      days: input.days,
                                                      _type: input._type,
                                                      subType: input.subType,
                                                      displayFilters: input.displayFilters,
                                                      allocationRadiusManual: input.allocationRadiusManual,
                                                      allocationRadiusAutomatic: value,
                                                      thresholdDistance: input.thresholdDistance,
                                                      dryRunRatio: input.dryRunRatio,
                                                      maxDryRunManual: input.maxDryRunManual,
                                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), false, undefined, "", undefined, undefined, undefined, form.allocationRadiusAutomaticResult, undefined, "ald-create-form-item-input", undefined, {
                              TAG: /* Text */0,
                              _0: "Value cannot be 0 or negative."
                            }, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: value$3 !== undefined ? value$3 : ""
                        }
                      })));
          break;
      case /* DryRun */1 :
          var value$4 = form.input.thresholdDistance;
          var value$5 = form.input.dryRunRatio;
          tmp$2 = React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "ald-create-form-item"
                  }, React.createElement("div", {
                        className: "ald-create-form-item-label"
                      }, "Threshold ", React.createElement("label", {
                            className: "unit"
                          }, "(km)"), React.createElement("label", {
                            className: "required"
                          }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                return Curry._2(form.updateThresholdDistance, (function (input, value) {
                                              return {
                                                      zones: input.zones,
                                                      hasCluster: input.hasCluster,
                                                      clusters: input.clusters,
                                                      campaignName: input.campaignName,
                                                      startDate: input.startDate,
                                                      startTime: input.startTime,
                                                      endDate: input.endDate,
                                                      endTime: input.endTime,
                                                      days: input.days,
                                                      _type: input._type,
                                                      subType: input.subType,
                                                      displayFilters: input.displayFilters,
                                                      allocationRadiusManual: input.allocationRadiusManual,
                                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                      thresholdDistance: value,
                                                      dryRunRatio: input.dryRunRatio,
                                                      maxDryRunManual: input.maxDryRunManual,
                                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), false, undefined, "", undefined, undefined, undefined, form.thresholdDistanceResult, undefined, "ald-create-form-item-input", undefined, {
                              TAG: /* Text */0,
                              _0: "Value cannot be 0 or negative."
                            }, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: value$4 !== undefined ? value$4 : ""
                        }
                      })), React.createElement("div", {
                    className: "ald-create-form-item"
                  }, React.createElement("div", {
                        className: "ald-create-form-item-label"
                      }, "Ratio", React.createElement("label", {
                            className: "required"
                          }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                return Curry._2(form.updateDryRunRatio, (function (input, value) {
                                              return {
                                                      zones: input.zones,
                                                      hasCluster: input.hasCluster,
                                                      clusters: input.clusters,
                                                      campaignName: input.campaignName,
                                                      startDate: input.startDate,
                                                      startTime: input.startTime,
                                                      endDate: input.endDate,
                                                      endTime: input.endTime,
                                                      days: input.days,
                                                      _type: input._type,
                                                      subType: input.subType,
                                                      displayFilters: input.displayFilters,
                                                      allocationRadiusManual: input.allocationRadiusManual,
                                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                      thresholdDistance: input.thresholdDistance,
                                                      dryRunRatio: value,
                                                      maxDryRunManual: input.maxDryRunManual,
                                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), false, undefined, "", undefined, undefined, undefined, form.dryRunRatioResult, undefined, "ald-create-form-item-input", undefined, {
                              TAG: /* Text */0,
                              _0: "Enter value between 0 and 2"
                            }, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: value$5 !== undefined ? value$5 : ""
                        }
                      })));
          break;
      case /* MaxDryRun */2 :
          var value$6 = form.input.maxDryRunManual;
          var value$7 = form.input.maxDryRunAutomatic;
          tmp$2 = React.createElement("div", undefined, React.createElement("div", {
                    className: "ald-create-form-item"
                  }, React.createElement("div", {
                        className: "ald-create-form-item-label"
                      }, "Manual ", React.createElement("label", {
                            className: "unit"
                          }, "(km)"), React.createElement("label", {
                            className: "required"
                          }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                return Curry._2(form.updateMaxDryRunManual, (function (input, value) {
                                              return {
                                                      zones: input.zones,
                                                      hasCluster: input.hasCluster,
                                                      clusters: input.clusters,
                                                      campaignName: input.campaignName,
                                                      startDate: input.startDate,
                                                      startTime: input.startTime,
                                                      endDate: input.endDate,
                                                      endTime: input.endTime,
                                                      days: input.days,
                                                      _type: input._type,
                                                      subType: input.subType,
                                                      displayFilters: input.displayFilters,
                                                      allocationRadiusManual: input.allocationRadiusManual,
                                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                      thresholdDistance: input.thresholdDistance,
                                                      dryRunRatio: input.dryRunRatio,
                                                      maxDryRunManual: value,
                                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), false, undefined, "", undefined, undefined, undefined, form.maxDryRunManualResult, undefined, "ald-create-form-item-input", undefined, {
                              TAG: /* Text */0,
                              _0: "Value cannot be 0 or negative."
                            }, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: value$6 !== undefined ? value$6 : ""
                        }
                      })), React.createElement("div", {
                    className: "ald-create-form-item"
                  }, React.createElement("div", {
                        className: "ald-create-form-item-label"
                      }, "Automatic ", React.createElement("label", {
                            className: "unit"
                          }, "(km)"), React.createElement("label", {
                            className: "required"
                          }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                return Curry._2(form.updateMaxDryRunAutomatic, (function (input, value) {
                                              return {
                                                      zones: input.zones,
                                                      hasCluster: input.hasCluster,
                                                      clusters: input.clusters,
                                                      campaignName: input.campaignName,
                                                      startDate: input.startDate,
                                                      startTime: input.startTime,
                                                      endDate: input.endDate,
                                                      endTime: input.endTime,
                                                      days: input.days,
                                                      _type: input._type,
                                                      subType: input.subType,
                                                      displayFilters: input.displayFilters,
                                                      allocationRadiusManual: input.allocationRadiusManual,
                                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                      thresholdDistance: input.thresholdDistance,
                                                      dryRunRatio: input.dryRunRatio,
                                                      maxDryRunManual: input.maxDryRunManual,
                                                      maxDryRunAutomatic: value
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), false, undefined, "", undefined, undefined, undefined, form.maxDryRunAutomaticResult, undefined, "ald-create-form-item-input", undefined, {
                              TAG: /* Text */0,
                              _0: "Value cannot be 0 or negative."
                            }, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: value$7 !== undefined ? value$7 : ""
                        }
                      })));
          break;
      
    }
    tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
              className: "ald-create-campaign-item-filters ald-create-form-item"
            }, React.createElement("div", {
                  className: "ald-create-form-item-label"
                }, tmp$1), React.createElement("p", {
                  className: "ald-create-zonal-cluster-campaign-action-wrapper",
                  onClick: (function (param) {
                      Curry._2(form.updateDisplayFilters, (function (input, value) {
                              return {
                                      zones: input.zones,
                                      hasCluster: input.hasCluster,
                                      clusters: input.clusters,
                                      campaignName: input.campaignName,
                                      startDate: input.startDate,
                                      startTime: input.startTime,
                                      endDate: input.endDate,
                                      endTime: input.endTime,
                                      days: input.days,
                                      _type: input._type,
                                      subType: input.subType,
                                      displayFilters: value,
                                      allocationRadiusManual: input.allocationRadiusManual,
                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                      thresholdDistance: input.thresholdDistance,
                                      dryRunRatio: input.dryRunRatio,
                                      maxDryRunManual: input.maxDryRunManual,
                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                    };
                            }), false);
                      Curry._2(form.updateSubType, (function (input, value) {
                              return {
                                      zones: input.zones,
                                      hasCluster: input.hasCluster,
                                      clusters: input.clusters,
                                      campaignName: input.campaignName,
                                      startDate: input.startDate,
                                      startTime: input.startTime,
                                      endDate: input.endDate,
                                      endTime: input.endTime,
                                      days: input.days,
                                      _type: input._type,
                                      subType: value,
                                      displayFilters: input.displayFilters,
                                      allocationRadiusManual: input.allocationRadiusManual,
                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                      thresholdDistance: input.thresholdDistance,
                                      dryRunRatio: input.dryRunRatio,
                                      maxDryRunManual: input.maxDryRunManual,
                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                    };
                            }), undefined);
                      Curry._2(form.updateAllocationRadiusAutomatic, (function (input, _value) {
                              return {
                                      zones: input.zones,
                                      hasCluster: input.hasCluster,
                                      clusters: input.clusters,
                                      campaignName: input.campaignName,
                                      startDate: input.startDate,
                                      startTime: input.startTime,
                                      endDate: input.endDate,
                                      endTime: input.endTime,
                                      days: input.days,
                                      _type: input._type,
                                      subType: input.subType,
                                      displayFilters: input.displayFilters,
                                      allocationRadiusManual: input.allocationRadiusManual,
                                      allocationRadiusAutomatic: undefined,
                                      thresholdDistance: input.thresholdDistance,
                                      dryRunRatio: input.dryRunRatio,
                                      maxDryRunManual: input.maxDryRunManual,
                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                    };
                            }), undefined);
                      Curry._2(form.updateAllocationRadiusManual, (function (input, _value) {
                              return {
                                      zones: input.zones,
                                      hasCluster: input.hasCluster,
                                      clusters: input.clusters,
                                      campaignName: input.campaignName,
                                      startDate: input.startDate,
                                      startTime: input.startTime,
                                      endDate: input.endDate,
                                      endTime: input.endTime,
                                      days: input.days,
                                      _type: input._type,
                                      subType: input.subType,
                                      displayFilters: input.displayFilters,
                                      allocationRadiusManual: undefined,
                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                      thresholdDistance: input.thresholdDistance,
                                      dryRunRatio: input.dryRunRatio,
                                      maxDryRunManual: input.maxDryRunManual,
                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                    };
                            }), undefined);
                      Curry._2(form.updateThresholdDistance, (function (input, _value) {
                              return {
                                      zones: input.zones,
                                      hasCluster: input.hasCluster,
                                      clusters: input.clusters,
                                      campaignName: input.campaignName,
                                      startDate: input.startDate,
                                      startTime: input.startTime,
                                      endDate: input.endDate,
                                      endTime: input.endTime,
                                      days: input.days,
                                      _type: input._type,
                                      subType: input.subType,
                                      displayFilters: input.displayFilters,
                                      allocationRadiusManual: input.allocationRadiusManual,
                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                      thresholdDistance: undefined,
                                      dryRunRatio: input.dryRunRatio,
                                      maxDryRunManual: input.maxDryRunManual,
                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                    };
                            }), undefined);
                      Curry._2(form.updateDryRunRatio, (function (input, _value) {
                              return {
                                      zones: input.zones,
                                      hasCluster: input.hasCluster,
                                      clusters: input.clusters,
                                      campaignName: input.campaignName,
                                      startDate: input.startDate,
                                      startTime: input.startTime,
                                      endDate: input.endDate,
                                      endTime: input.endTime,
                                      days: input.days,
                                      _type: input._type,
                                      subType: input.subType,
                                      displayFilters: input.displayFilters,
                                      allocationRadiusManual: input.allocationRadiusManual,
                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                      thresholdDistance: input.thresholdDistance,
                                      dryRunRatio: undefined,
                                      maxDryRunManual: input.maxDryRunManual,
                                      maxDryRunAutomatic: input.maxDryRunAutomatic
                                    };
                            }), undefined);
                      Curry._2(form.updateMaxDryRunAutomatic, (function (input, _value) {
                              return {
                                      zones: input.zones,
                                      hasCluster: input.hasCluster,
                                      clusters: input.clusters,
                                      campaignName: input.campaignName,
                                      startDate: input.startDate,
                                      startTime: input.startTime,
                                      endDate: input.endDate,
                                      endTime: input.endTime,
                                      days: input.days,
                                      _type: input._type,
                                      subType: input.subType,
                                      displayFilters: input.displayFilters,
                                      allocationRadiusManual: input.allocationRadiusManual,
                                      allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                      thresholdDistance: input.thresholdDistance,
                                      dryRunRatio: input.dryRunRatio,
                                      maxDryRunManual: input.maxDryRunManual,
                                      maxDryRunAutomatic: undefined
                                    };
                            }), undefined);
                      return Curry._2(form.updateMaxDryRunManual, (function (input, _value) {
                                    return {
                                            zones: input.zones,
                                            hasCluster: input.hasCluster,
                                            clusters: input.clusters,
                                            campaignName: input.campaignName,
                                            startDate: input.startDate,
                                            startTime: input.startTime,
                                            endDate: input.endDate,
                                            endTime: input.endTime,
                                            days: input.days,
                                            _type: input._type,
                                            subType: input.subType,
                                            displayFilters: input.displayFilters,
                                            allocationRadiusManual: input.allocationRadiusManual,
                                            allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                            thresholdDistance: input.thresholdDistance,
                                            dryRunRatio: input.dryRunRatio,
                                            maxDryRunManual: undefined,
                                            maxDryRunAutomatic: input.maxDryRunAutomatic
                                          };
                                  }), undefined);
                    })
                }, React.createElement("img", {
                      className: "ald-create-zonal-cluster-campaign-remove-icon",
                      src: cancelIcon
                    }), React.createElement("label", {
                      className: "ald-create-zonal-cluster-campaign-action-label"
                    }, "Remove"))), React.createElement("div", {
              className: "ald-create-campaign-item-filters"
            }, tmp$2), React.createElement("span", {
              className: "ald-create-zonal-cluster-campaign-note-text"
            }, AllocationDashboardContent.click_remove_to_select_a_different_filter));
  } else {
    tmp = null;
  }
  return React.createElement("form", {
              className: "ald-create-campaign-form"
            }, React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Zone", React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateZones, (function (input, value) {
                                            return {
                                                    zones: value,
                                                    hasCluster: input.hasCluster,
                                                    clusters: input.clusters,
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    endDate: input.endDate,
                                                    endTime: input.endTime,
                                                    days: input.days,
                                                    _type: input._type,
                                                    subType: input.subType,
                                                    displayFilters: input.displayFilters,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic
                                                  };
                                          }), FormHelper$Catalyst.TargetListEventWrapper.listValue($$event));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.zonesResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      select_props: {
                        selected: form.input.zones,
                        options: CreateModificationUtils.ZoneUtils.zonesToCheckBoxItems(zones),
                        renderValue: (function (values) {
                            return CreateModificationUtils.ZoneUtils.getZoneSelectDisplayData(values, zones);
                          })
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item-input-switch"
                }, React.createElement("div", {
                      className: List.length(form.input.zones) > 1 ? "ald-create-form-item-switch-disabled-text" : "ald-create-form-item-label"
                    }, "Add Cluster"), React.createElement(Switch$Catalyst.make, {
                      checked: form.input.hasCluster,
                      on_change: (function (_event) {
                          var currentState = form.input.hasCluster;
                          Curry._2(form.updateHasCluster, (function (input, _value) {
                                  return {
                                          zones: input.zones,
                                          hasCluster: !currentState,
                                          clusters: input.clusters,
                                          campaignName: input.campaignName,
                                          startDate: input.startDate,
                                          startTime: input.startTime,
                                          endDate: input.endDate,
                                          endTime: input.endTime,
                                          days: input.days,
                                          _type: input._type,
                                          subType: input.subType,
                                          displayFilters: input.displayFilters,
                                          allocationRadiusManual: input.allocationRadiusManual,
                                          allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                          thresholdDistance: input.thresholdDistance,
                                          dryRunRatio: input.dryRunRatio,
                                          maxDryRunManual: input.maxDryRunManual,
                                          maxDryRunAutomatic: input.maxDryRunAutomatic
                                        };
                                }), !currentState);
                          Curry._1(setShowClusterCampaigns, (function (param) {
                                  return !showClusterCampaigns;
                                }));
                          return Curry._2(form.updateClusters, (function (input, _value) {
                                        return {
                                                zones: input.zones,
                                                hasCluster: input.hasCluster,
                                                clusters: /* [] */0,
                                                campaignName: input.campaignName,
                                                startDate: input.startDate,
                                                startTime: input.startTime,
                                                endDate: input.endDate,
                                                endTime: input.endTime,
                                                days: input.days,
                                                _type: input._type,
                                                subType: input.subType,
                                                displayFilters: input.displayFilters,
                                                allocationRadiusManual: input.allocationRadiusManual,
                                                allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                thresholdDistance: input.thresholdDistance,
                                                dryRunRatio: input.dryRunRatio,
                                                maxDryRunManual: input.maxDryRunManual,
                                                maxDryRunAutomatic: input.maxDryRunAutomatic
                                              };
                                      }), /* [] */0);
                        }),
                      class_name: "ald-create-form-item-switch",
                      switch_color: /* Primary */1
                    })), form.input.hasCluster ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "ald-create-form-item"
                      }, React.createElement("div", {
                            className: "ald-create-form-item-label"
                          }, "Cluster", React.createElement("label", {
                                className: "required"
                              }, " *")), React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
                            input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                    return Curry._2(form.updateClusters, (function (input, value) {
                                                  return {
                                                          zones: input.zones,
                                                          hasCluster: input.hasCluster,
                                                          clusters: value,
                                                          campaignName: input.campaignName,
                                                          startDate: input.startDate,
                                                          startTime: input.startTime,
                                                          endDate: input.endDate,
                                                          endTime: input.endTime,
                                                          days: input.days,
                                                          _type: input._type,
                                                          subType: input.subType,
                                                          displayFilters: input.displayFilters,
                                                          allocationRadiusManual: input.allocationRadiusManual,
                                                          allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                          thresholdDistance: input.thresholdDistance,
                                                          dryRunRatio: input.dryRunRatio,
                                                          maxDryRunManual: input.maxDryRunManual,
                                                          maxDryRunAutomatic: input.maxDryRunAutomatic
                                                        };
                                                }), FormHelper$Catalyst.TargetListEventWrapper.listValue($$event));
                                  }), List.length(form.input.zones) === 0, undefined, undefined, undefined, undefined, undefined, form.clustersResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                            select_props: {
                              selected: form.input.clusters,
                              options: CreateModificationUtils.ClusterUtils.clustersToCheckBoxItemsForSelectedZone(clusters, Belt_List.get(form.input.zones, 0)),
                              renderValue: (function (values) {
                                  return CreateModificationUtils.ClusterUtils.getClusterSelectDisplayData(values, clusters);
                                })
                            }
                          }))) : null, React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Campaign Name", React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateCampaignName, (function (input, value) {
                                            return {
                                                    zones: input.zones,
                                                    hasCluster: input.hasCluster,
                                                    clusters: input.clusters,
                                                    campaignName: value,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    endDate: input.endDate,
                                                    endTime: input.endTime,
                                                    days: input.days,
                                                    _type: input._type,
                                                    subType: input.subType,
                                                    displayFilters: input.displayFilters,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), false, undefined, "Enter Campaign Name", undefined, undefined, undefined, form.campaignNameResult, undefined, undefined, undefined, {
                            TAG: /* Text */0,
                            _0: "Campaign Names cannot be more than 60 characters"
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: value !== undefined ? value : ""
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Start Date", React.createElement("label", {
                          className: "required"
                        }, " *")), React.createElement(FormDateInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), undefined, undefined, "Select the start date", undefined, undefined, undefined, form.startDateResult, undefined, "ald-create-form-item-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      date_props: {
                        value: form.input.startDate,
                        minDate: Caml_option.some(Date$Catalyst.toJsDate(Date$Catalyst.tomorrow(undefined))),
                        maxDate: undefined,
                        onChange: (function (date) {
                            return Curry._2(form.updateStartDate, (function (input, value) {
                                          return {
                                                  zones: input.zones,
                                                  hasCluster: input.hasCluster,
                                                  clusters: input.clusters,
                                                  campaignName: input.campaignName,
                                                  startDate: value,
                                                  startTime: input.startTime,
                                                  endDate: input.endDate,
                                                  endTime: input.endTime,
                                                  days: input.days,
                                                  _type: input._type,
                                                  subType: input.subType,
                                                  displayFilters: input.displayFilters,
                                                  allocationRadiusManual: input.allocationRadiusManual,
                                                  allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                  thresholdDistance: input.thresholdDistance,
                                                  dryRunRatio: input.dryRunRatio,
                                                  maxDryRunManual: input.maxDryRunManual,
                                                  maxDryRunAutomatic: input.maxDryRunAutomatic
                                                };
                                        }), Caml_option.some(date));
                          }),
                        format: "DD MMM YYYY",
                        autoOk: true,
                        views: [
                          "year",
                          "month",
                          "date"
                        ]
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Start Time"), React.createElement(FormKeyInputTimeTs$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), undefined, undefined, "Select the start time", undefined, undefined, undefined, form.startTimeResult, undefined, "ald-create-form-item-input", undefined, {
                            TAG: /* Text */0,
                            _0: ""
                          }, undefined, undefined, undefined, undefined, undefined),
                      time_props: {
                        value: form.input.startTime,
                        onChange: (function (date) {
                            return Curry._2(form.updateStartTime, (function (input, value) {
                                          return {
                                                  zones: input.zones,
                                                  hasCluster: input.hasCluster,
                                                  clusters: input.clusters,
                                                  campaignName: input.campaignName,
                                                  startDate: input.startDate,
                                                  startTime: value,
                                                  endDate: input.endDate,
                                                  endTime: input.endTime,
                                                  days: input.days,
                                                  _type: input._type,
                                                  subType: input.subType,
                                                  displayFilters: input.displayFilters,
                                                  allocationRadiusManual: input.allocationRadiusManual,
                                                  allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                  thresholdDistance: input.thresholdDistance,
                                                  dryRunRatio: input.dryRunRatio,
                                                  maxDryRunManual: input.maxDryRunManual,
                                                  maxDryRunAutomatic: input.maxDryRunAutomatic
                                                };
                                        }), date);
                          }),
                        format: "hh:mm A",
                        ampm: true,
                        isDisabled: false
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "End Date (Campaign)"), React.createElement(FormDateInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), undefined, undefined, "Select the end date", undefined, undefined, undefined, form.endDateResult, undefined, "ald-create-form-item-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      date_props: {
                        value: form.input.endDate,
                        minDate: form.input.startDate,
                        maxDate: undefined,
                        onChange: (function (date) {
                            return Curry._2(form.updateEndDate, (function (input, value) {
                                          return {
                                                  zones: input.zones,
                                                  hasCluster: input.hasCluster,
                                                  clusters: input.clusters,
                                                  campaignName: input.campaignName,
                                                  startDate: input.startDate,
                                                  startTime: input.startTime,
                                                  endDate: value,
                                                  endTime: input.endTime,
                                                  days: input.days,
                                                  _type: input._type,
                                                  subType: input.subType,
                                                  displayFilters: input.displayFilters,
                                                  allocationRadiusManual: input.allocationRadiusManual,
                                                  allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                  thresholdDistance: input.thresholdDistance,
                                                  dryRunRatio: input.dryRunRatio,
                                                  maxDryRunManual: input.maxDryRunManual,
                                                  maxDryRunAutomatic: input.maxDryRunAutomatic
                                                };
                                        }), Caml_option.some(date));
                          }),
                        format: "DD MMM YYYY",
                        autoOk: true,
                        views: [
                          "year",
                          "month",
                          "date"
                        ]
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "End Time"), React.createElement(FormKeyInputTimeTs$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (param) {
                              
                            }), undefined, undefined, "Select the end time", undefined, undefined, undefined, form.endTimeResult, undefined, "ald-create-form-item-input", undefined, {
                            TAG: /* Text */0,
                            _0: ""
                          }, undefined, undefined, undefined, undefined, undefined),
                      time_props: {
                        value: form.input.endTime,
                        onChange: (function (date) {
                            return Curry._2(form.updateEndTime, (function (input, value) {
                                          return {
                                                  zones: input.zones,
                                                  hasCluster: input.hasCluster,
                                                  clusters: input.clusters,
                                                  campaignName: input.campaignName,
                                                  startDate: input.startDate,
                                                  startTime: input.startTime,
                                                  endDate: input.endDate,
                                                  endTime: value,
                                                  days: input.days,
                                                  _type: input._type,
                                                  subType: input.subType,
                                                  displayFilters: input.displayFilters,
                                                  allocationRadiusManual: input.allocationRadiusManual,
                                                  allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                  thresholdDistance: input.thresholdDistance,
                                                  dryRunRatio: input.dryRunRatio,
                                                  maxDryRunManual: input.maxDryRunManual,
                                                  maxDryRunAutomatic: input.maxDryRunAutomatic
                                                };
                                        }), date);
                          }),
                        format: "hh:mm A",
                        ampm: true,
                        isDisabled: false
                      }
                    })), React.createElement("div", {
                  className: "ald-create-form-item"
                }, React.createElement("div", {
                      className: "ald-create-form-item-label"
                    }, "Days"), React.createElement(FormSelectWithCheckboxInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateDays, (function (input, value) {
                                            return {
                                                    zones: input.zones,
                                                    hasCluster: input.hasCluster,
                                                    clusters: input.clusters,
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    endDate: input.endDate,
                                                    endTime: input.endTime,
                                                    days: sortDays(value),
                                                    _type: input._type,
                                                    subType: input.subType,
                                                    displayFilters: input.displayFilters,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic
                                                  };
                                          }), FormHelper$Catalyst.TargetListEventWrapper.listValue($$event));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.daysResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      select_props: {
                        selected: form.input.days,
                        options: CreateModificationUtils.RepeatDays.daysOptions,
                        renderValue: undefined
                      }
                    })), match$1 ? React.createElement(React.Fragment, undefined) : React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "ald-create-form-item"
                      }, React.createElement(PrimaryButton$Catalyst.make, {
                            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                  TAG: /* Custom */1,
                                  _0: (function (param) {
                                      return React.createElement("p", {
                                                  className: "ald-create-zonal-cluster-campaign-filter-type-text"
                                                }, "+ Allocation Radius");
                                    })
                                }, false, (function (_event) {
                                    Curry._2(form.updateDisplayFilters, (function (input, _value) {
                                            return {
                                                    zones: input.zones,
                                                    hasCluster: input.hasCluster,
                                                    clusters: input.clusters,
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    endDate: input.endDate,
                                                    endTime: input.endTime,
                                                    days: input.days,
                                                    _type: input._type,
                                                    subType: input.subType,
                                                    displayFilters: true,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic
                                                  };
                                          }), !form.input.displayFilters);
                                    return Curry._2(form.updateSubType, (function (input, value) {
                                                  return {
                                                          zones: input.zones,
                                                          hasCluster: input.hasCluster,
                                                          clusters: input.clusters,
                                                          campaignName: input.campaignName,
                                                          startDate: input.startDate,
                                                          startTime: input.startTime,
                                                          endDate: input.endDate,
                                                          endTime: input.endTime,
                                                          days: input.days,
                                                          _type: input._type,
                                                          subType: value,
                                                          displayFilters: input.displayFilters,
                                                          allocationRadiusManual: input.allocationRadiusManual,
                                                          allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                          thresholdDistance: input.thresholdDistance,
                                                          dryRunRatio: input.dryRunRatio,
                                                          maxDryRunManual: input.maxDryRunManual,
                                                          maxDryRunAutomatic: input.maxDryRunAutomatic
                                                        };
                                                }), /* AllocationRadius */0);
                                  }), undefined, undefined, undefined, undefined, "ald-create-zonal-cluster-campaign-filter-type-btn", undefined, undefined)
                          }), React.createElement(PrimaryButton$Catalyst.make, {
                            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                  TAG: /* Custom */1,
                                  _0: (function (param) {
                                      return React.createElement("p", {
                                                  className: "ald-create-zonal-cluster-campaign-filter-type-text"
                                                }, "+ Dry Run Ratio");
                                    })
                                }, false, (function (_event) {
                                    Curry._2(form.updateDisplayFilters, (function (input, _value) {
                                            return {
                                                    zones: input.zones,
                                                    hasCluster: input.hasCluster,
                                                    clusters: input.clusters,
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    endDate: input.endDate,
                                                    endTime: input.endTime,
                                                    days: input.days,
                                                    _type: input._type,
                                                    subType: input.subType,
                                                    displayFilters: true,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic
                                                  };
                                          }), !form.input.displayFilters);
                                    return Curry._2(form.updateSubType, (function (input, value) {
                                                  return {
                                                          zones: input.zones,
                                                          hasCluster: input.hasCluster,
                                                          clusters: input.clusters,
                                                          campaignName: input.campaignName,
                                                          startDate: input.startDate,
                                                          startTime: input.startTime,
                                                          endDate: input.endDate,
                                                          endTime: input.endTime,
                                                          days: input.days,
                                                          _type: input._type,
                                                          subType: value,
                                                          displayFilters: input.displayFilters,
                                                          allocationRadiusManual: input.allocationRadiusManual,
                                                          allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                          thresholdDistance: input.thresholdDistance,
                                                          dryRunRatio: input.dryRunRatio,
                                                          maxDryRunManual: input.maxDryRunManual,
                                                          maxDryRunAutomatic: input.maxDryRunAutomatic
                                                        };
                                                }), /* DryRun */1);
                                  }), undefined, undefined, undefined, undefined, "ald-create-zonal-cluster-campaign-filter-type-btn", undefined, undefined)
                          }), React.createElement(PrimaryButton$Catalyst.make, {
                            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                  TAG: /* Custom */1,
                                  _0: (function (param) {
                                      return React.createElement("p", {
                                                  className: "ald-create-zonal-cluster-campaign-filter-type-text"
                                                }, "+ Max Dry Run");
                                    })
                                }, false, (function (_event) {
                                    Curry._2(form.updateDisplayFilters, (function (input, _value) {
                                            return {
                                                    zones: input.zones,
                                                    hasCluster: input.hasCluster,
                                                    clusters: input.clusters,
                                                    campaignName: input.campaignName,
                                                    startDate: input.startDate,
                                                    startTime: input.startTime,
                                                    endDate: input.endDate,
                                                    endTime: input.endTime,
                                                    days: input.days,
                                                    _type: input._type,
                                                    subType: /* MaxDryRun */2,
                                                    displayFilters: true,
                                                    allocationRadiusManual: input.allocationRadiusManual,
                                                    allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                    thresholdDistance: input.thresholdDistance,
                                                    dryRunRatio: input.dryRunRatio,
                                                    maxDryRunManual: input.maxDryRunManual,
                                                    maxDryRunAutomatic: input.maxDryRunAutomatic
                                                  };
                                          }), !form.input.displayFilters);
                                    return Curry._2(form.updateSubType, (function (input, value) {
                                                  return {
                                                          zones: input.zones,
                                                          hasCluster: input.hasCluster,
                                                          clusters: input.clusters,
                                                          campaignName: input.campaignName,
                                                          startDate: input.startDate,
                                                          startTime: input.startTime,
                                                          endDate: input.endDate,
                                                          endTime: input.endTime,
                                                          days: input.days,
                                                          _type: input._type,
                                                          subType: value,
                                                          displayFilters: input.displayFilters,
                                                          allocationRadiusManual: input.allocationRadiusManual,
                                                          allocationRadiusAutomatic: input.allocationRadiusAutomatic,
                                                          thresholdDistance: input.thresholdDistance,
                                                          dryRunRatio: input.dryRunRatio,
                                                          maxDryRunManual: input.maxDryRunManual,
                                                          maxDryRunAutomatic: input.maxDryRunAutomatic
                                                        };
                                                }), /* MaxDryRun */2);
                                  }), undefined, undefined, undefined, undefined, "ald-create-zonal-cluster-campaign-filter-type-btn", undefined, undefined)
                          })), React.createElement("span", {
                        className: match[0] ? "ald-create-zonal-cluster-campaign-note-error-text ald-create-zonal-cluster-campaign-filter-text" : "ald-create-zonal-cluster-campaign-note-text ald-create-zonal-cluster-campaign-filter-text"
                      }, AllocationDashboardContent.only_one_filter_can_be_selected)), tmp, React.createElement(AllocationCampaignFooterCmp.make, {
                  onLeftBtnClick: (function (param) {
                      if (Curry._1(form.dirty, undefined)) {
                        return Curry._1(dispatch, {
                                    TAG: /* OpenModal */10,
                                    modal: {
                                      isOpen: true,
                                      onCancel: (function (param) {
                                          return Curry._1(dispatch, /* CloseModal */3);
                                        }),
                                      onSubmit: (function (param) {
                                          Curry._1(dispatch, {
                                                TAG: /* UpdateSidebarState */6,
                                                opened_sidebar: /* CreateCampaignContainer */0
                                              });
                                          return Curry._1(dispatch, /* CloseModal */3);
                                        }),
                                      title: "Discard Changes",
                                      confirm_button_title: "Yes, Discard",
                                      cancel_button_title: "No, Cancel",
                                      modal_body: "You are about to leave this page. All the changes will be lost. Are you sure you wish to exit?"
                                    }
                                  });
                      } else {
                        return Curry._1(dispatch, {
                                    TAG: /* UpdateSidebarState */6,
                                    opened_sidebar: /* CreateCampaignContainer */0
                                  });
                      }
                    }),
                  leftBtnText: "Back",
                  onRightBtnClick: (function (param) {
                      if (form.input.subType === undefined) {
                        return Curry._1(setDisplayErrorText, (function (param) {
                                      return true;
                                    }));
                      } else {
                        return Curry._1(form.submit, undefined);
                      }
                    }),
                  rightBtnText: "Preview"
                }));
}

var make = CreateZonalOrClusterCampaigns;

export {
  cancelIcon ,
  infoIcon ,
  getInitialFormState ,
  sortDays ,
  make ,
  
}
/* cancelIcon Not a pure module */
